import React, { useState } from 'react';
import styled from 'styled-components/macro';
import Modal from 'components/Modal';
import Dropdown from 'components/Input/dropdown/Dropdown';
import RadioButton from 'components/Buttons/RadioButton';
import Textarea from 'components/Input/Textarea';
import Table from 'components/Table';
import Chip from 'components/Chip/Chip';
// import utils from 'utils'

const ModalWrapper = styled.div`
  /* border:2px solid red;
box-sizing: border-box; */
  max-width: 750px;
  overflow: hidden;
`;

const Top = styled.div`
  margin: 1px;
  /* border:2px solid green;
box-sizing: border-box; */
`;

const ChipListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 22px;
  margin-bottom: 27px;
  /* border:2px solid purple;
box-sizing: border-box; */
`;

const ChipContainer = styled.div`
  width: 90%;
  display: flex;
  flex-direction: row;
  padding-left: 10px;
  align-items: center;
  /* border:2px solid orange;
box-sizing: border-box; */
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* border:2px solid grey;
box-sizing: border-box; */
`;

const Left = styled.div`
  > div {
    margin-bottom: 18px;
  }
`;

const Right = styled.div`
  width: 50%;
  > div {
    margin-bottom: 10px;
  }

  textarea {
    height: 70px;
    min-height: 70px;
  }
`;

const Label = styled.p`
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
`;

const Bottom = styled.div`
  height: 200px;
  display: table;
`;

const WorkflowLog = () => {
  // const t = utils.intl.useTranslator();
  // #region mockData
  const onConfirm = () => {
    console.log('confirm');
  };

  const mockCol = [
    { accessor: 'id', Header: 'Id' },
    { accessor: 'index', Header: 'Index' },
    { accessor: 'randomNumber', Header: 'randomNumber' },
    { accessor: 'age', Header: 'Age' },
    { accessor: 'month', Header: 'Month' },
    { accessor: 'data', Header: 'City' },
    { accessor: 'scan', Header: 'City' },
    { accessor: 'soemthing', Header: 'City' },
    { accessor: 'mock', Header: 'City' },
    { accessor: 'mockagain', Header: 'City' },
  ];
  const mockRows = [];
  for (let i = 0; i < 10; i++) {
    mockRows.push({ index: i, id: i + 99, randomNumber: Math.random() });
  }

  const mockRadioOptions = [
    { value: '0', label: 'Referente' },
    { value: '1', label: 'Procuratore' },
    { value: '2', label: 'Integrativo' },
    { value: '3', label: 'Altro' },
  ];
  const mockDropDownOptions = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },
  ];
  const generateChip = (arg: number) => {
    const onChipClick = () => console.log('chip clicked');
    return new Array(arg).fill(<Chip text="mockchip" onClick={onChipClick} />);
  };
  const [selected, setSelected] = useState('');
  // #endregion

  return (
    <ModalWrapper>
      <Top>
        <Modal.Header
          title="Workflow Log"
          subtitle="Please fill the form to send the document to the correct workflow recipient,
          specifiyng the Reason Why.
          You can add a Log Note related to the document, in the field below."
          customWidth="665px"
          noMargin
        />
        <ChipListWrapper>
          <Label>To :</Label>
          <ChipContainer>{generateChip(10)}</ChipContainer>
        </ChipListWrapper>
      </Top>
      <FlexContainer>
        <Left>
          <Label>Select Recipients</Label>
          <Dropdown id="recipients-dropdown" options={mockDropDownOptions} />
          {generateChip(2)}
        </Left>
        <RadioButton
          options={mockRadioOptions}
          onChange={(value) => {
            // @ts-ignore
            setSelected(value);
          }}
          value={selected}
        />
        <Right>
          <Dropdown id="dropdown-1" customHeight="38px" options={mockDropDownOptions} />
          <Dropdown id="dropdown-2" customHeight="38px" options={mockDropDownOptions} />
          <Dropdown id="dropdown-3" customHeight="38px" options={mockDropDownOptions} />
        </Right>
      </FlexContainer>
      <FlexContainer>
        <Left>
          <Label>Reason why</Label>
          <Dropdown id="reason-dropdown" options={mockDropDownOptions} />
        </Left>
        <Right>
          <Label>Log notes</Label>
          <Textarea minWidth="150px" onChange={(e) => console.log(e.target.value)} />
        </Right>
      </FlexContainer>
      <Bottom>
        <Label>Document History</Label>
        <Table id="workflow-log-table" rows={mockRows} columns={mockCol} pageSize={5} hasPagination hasFilter hasSort />
      </Bottom>
      <Modal.Footer confirmText={'save-log'} confirmAction={onConfirm} />
    </ModalWrapper>
  );
};

export default WorkflowLog;
